import { supabase } from './supabase';

/**
 * Retry getSession() up to maxAttempts times, waiting delayMs between each.
 * Necessary because PKCE code exchange and session storage writes are async —
 * the session may not be readable immediately after a redirect lands.
 *
 * @param {number} maxAttempts
 * @param {number} delayMs
 * @returns {Promise<{ session: import('@supabase/supabase-js').Session|null }>}
 */
export const getSessionWithRetry = async (maxAttempts = 6, delayMs = 120) => {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.error('[AUTH] getSession error during retry:', error);
      break;
    }
    if (data?.session) return data;
    if (attempt < maxAttempts - 1) {
      await new Promise((r) => setTimeout(r, delayMs));
    }
  }
  return { session: null };
};
